import gql from "graphql-tag";

export const GET_BEST_TIME_SLICE_WGS_84_PNGS = gql`
  query GET_BEST_TIME_SLICE_WGS_84_PNGS(
    $boundary: [LocationInput]!
    $instant: ZonedDateTime!
    $dataSourceId: Long!
    $magnitudeVariableId: Long!
    $directionVariableId: Long!
  ) {
    magnitudes: bestTimeSliceWgs84PNG(
      input: {
        boundary: $boundary
        dataSourceId: $dataSourceId
        instant: $instant
        variableId: $magnitudeVariableId
      }
    ) {
      dataSource {
        id
      }
      instant
      leadTime
      data
      geojsonEnvelope
      srid
      summary {
        min
        max
      }
      variable {
        id
      }
    }
    directions: bestTimeSliceWgs84PNG(
      input: {
        boundary: $boundary
        dataSourceId: $dataSourceId
        instant: $instant
        variableId: $directionVariableId
      }
    ) {
      dataSource {
        id
      }
      instant
      leadTime
      data
      geojsonEnvelope
      srid
      summary {
        min
        max
      }
      variable {
        id
      }
    }
  }
`;
